/* eslint-disable-next-line padded-blocks */
import ReactDOMServer from "react-dom/server";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import "jspdf-autotable";

import { useContextSimulator } from "./SimulatorContext";

import { formatCurrency } from "../../../../utils/formatCurrency";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { useAppContext } from "../../../../context/AppContext";
import { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";

export default function SimulationInvoice() {
  const {
    clientData,
    publicClientData,
    memberData,
    entryParcelsTable,
    entryParcelCalc,
    financingParcelCalc,
    financingParcelsTable,
    intermediateParcelsTable,
    intermediateTotalValue,
    constructionTotalValue,
    constructionParcelsTable,
    simulationData,
    simulatorData,
    oneTimeParcelValue,
    oneTimeParcelDate,
    simulationId,
    toggle,
    oneTimeInstallments,
    oneTimeValueAndPercentage,
    selectedOneTimePayTerm,
    entryInterest,
    chooseEntry,
  } = useContextSimulator();

  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const [findValueAndPercentage, setFindValueAndPercentage] = useState(null);

  useEffect(() => {
    if (oneTimeValueAndPercentage && Array.isArray(oneTimeValueAndPercentage) && selectedOneTimePayTerm) {
      setFindValueAndPercentage(
        oneTimeValueAndPercentage.find((t) => t.term === selectedOneTimePayTerm)
      );
    } else {
      setFindValueAndPercentage(null);
    }
  }, [oneTimeValueAndPercentage, selectedOneTimePayTerm]);

  console.log("Member Data: ", memberData)
  console.log("Client Data: ", clientData)


  //  // console.log("member: ", memberData);
  //  // console.log("client: ", clientData);
  //  // console.log("entryParcelsTable: ", entryParcelsTable);
  //  // console.log("financingParcelsTable: ", financingParcelsTable);
  //  // console.log("simulationData: ", simulationData);
  //  // console.log("entryParcelCalc: ", entryParcelCalc);
  //  // console.log("financingParcelCalc: ", financingParcelCalc);
  //  // console.log("calc: ", formatCurrency(entryParcelCalc + financingParcelCalc));
  //  // console.log("findValueAndPercentage: ", findValueAndPercentage);

  const currentDate = new Date();
  const formattedDateLong = currentDate.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const formattedDateShort = currentDate.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  let entryViewTable = [];
  if (simulationData?.entry?.installments && Array.isArray(simulationData.entry.installments)) {
    entryViewTable = simulationData.entry.installments.map(e => ({
      value: formatCurrency(e?.value || 0),
      due_date: e?.due_date ? format(parseISO(e.due_date), "dd/MM/yyyy") : "-",
      sequence_number: e?.sequence_number || 0,
    }));
  }

  let financingViewTable = [];
  if (simulationData?.financing?.installments && Array.isArray(simulationData.financing.installments)) {
    financingViewTable = simulationData.financing.installments.map(f => ({
      value: formatCurrency(f?.value || 0),
      due_date: f?.due_date ? format(parseISO(f.due_date), "dd/MM/yyyy") : "-",
      sequence_number: f?.sequence_number || 0,
    }));
  }

  let constructionViewTable = [];
  if (simulationData?.construction?.installments && Array.isArray(simulationData.construction.installments)) {
    constructionViewTable = simulationData.construction.installments.map(c => ({
      value: formatCurrency(c?.value || 0),
      due_date: c?.due_date ? format(parseISO(c.due_date), "dd/MM/yyyy") : "-",
      sequence_number: c?.sequence_number || 0,
    }));
  }

  let intermediateViewTable = [];
  if (simulationData?.intermediate?.installments && Array.isArray(simulationData.intermediate.installments)) {
    intermediateViewTable = simulationData.intermediate.installments.map(i => ({
      value: formatCurrency(i?.value || 0),
      due_date: i?.due_date ? format(parseISO(i.due_date), "dd/MM/yyyy") : "-",
      sequence_number: i?.sequence_number || 0,
    }));
  }

  const getLastPhoneNumber = () => {
    if (!clientData || !clientData.contacts) {
      return 'Número de telefone não disponível';
    }

    let contactArray = [];

    // Verifica se clientData.contacts é uma string ou um array
    if (typeof clientData.contacts === 'string') {
      contactArray = clientData.contacts.split(',').map(contact => contact.trim()).filter(Boolean);
    } else if (Array.isArray(clientData.contacts)) {
      contactArray = clientData.contacts
        .map(contact => contact?.number || contact?.trim?.() || contact)
        .filter(Boolean);
    }

    // Verifica se o array tem algum valor e retorna o último contato
    return contactArray.length > 0 ? contactArray[contactArray.length - 1] : 'Número de telefone não disponível';
  };

  const Content = ({ print }) => (
    <div className="invoice">
      <div className="invoice-company">
        {!print && (
          <span className="float-end hidden-print">
            <button
              className="btn btn-sm btn-white mb-10px me-2"
              onClick={() => handlePrint()}
            >
              <i className="fa fa-file-pdf t-plus-1 text-danger fa-fw fa-lg"></i>{" "}
              Baixar como PDF
            </button>
          </span>
        )}
        {simulationData && simulatorData?.logo ? (
          <>
            <img
              src={`data:image/png;base64,${simulatorData.logo}`}
              width={100}
              alt={simulatorData?.enterprise_name || 'Logo da empresa'}
            />
            <br />
            {simulatorData?.enterprise_name || 'Empresa'}
          </>
        ) : (
          simulatorData?.enterprise_name || 'Empresa'
        )}
      </div>
      <div className="invoice-header">
        <div className="invoice-from">
          <small>Cliente</small>
          <address className="mt-5px mb-5px">
            <strong className="text-dark text-capitalize">
              {clientData?.name || 'Nome não informado'}
            </strong>
            <br />
            CPF: {clientData?.doc || 'Não informado'}
            {clientData?.address && (
              <>
                <br />
                {clientData.address.city || 'Cidade não informada'}, {clientData.address.cep || 'CEP não informado'}
              </>
            )}
            {clientData?.contacts?.length > 0 && (
              <>
                <br />
                Telefone: {clientData && getLastPhoneNumber()}
              </>
            )}
            {clientData?.email && <><br /> E-mail: {clientData.email} </>}
          </address>
        </div>
        {!publicClientData && (
          <div className="invoice-to">
            <small>Vendedor</small>
            <address className="mt-5px mb-5px">
              <strong className="text-dark">{memberData?.name || 'Vendedor não informado'}</strong>
              <br />
              {memberData?.doc && (
                <>
                  {memberData?.doc?.length <= 14 ? "CPF:" : "CNPJ:"} {memberData.doc}
                  <br />
                </>
              )}
              {memberData?.creci && (
                <>
                  CRECI: {memberData?.creci}
                  <br />
                </>
              )}
              {memberData?.contacts && Array.isArray(memberData.contacts) && memberData.contacts.length > 0 && (
                <>
                  Telefone: {memberData.contacts[memberData.contacts.length - 1]?.number || 'Não informado'}
                  <br />
                </>
              )}
              {memberData?.email && (<>E-mail: {memberData?.email} </>)}
            </address>
          </div>
        )}
        <div className="invoice-date">
          <small>Data da Simulação</small>
          <div className="date text-dark mt-5px">{formattedDateLong}</div>
          {!publicClientData && (
            <div className="invoice-detail">
              Simulação de Venda Número: {String(simulationId).padStart(5, "0")}
            </div>
          )}
        </div>
      </div>

      {!toggle ? (
        <div className="invoice-content">
          <div className="table-responsive">
            <table className="table table-invoice">
              <thead>
                <tr>
                  <th className="text-start">DESCRIÇÃO</th>
                  <th className="text-center" width="20%">
                    QTD PARCELAS
                  </th>
                  <th className="text-center" width="20%">
                    VALOR TOTAL
                  </th>
                </tr>
              </thead>
              <tbody>
                {entryParcelsTable && Array.isArray(entryParcelsTable) && entryParcelsTable.length > 0 && (
                  <tr>
                    <td>
                      <span className="text-dark">Parcela Entrada</span>
                    </td>
                    <td className="text-center">
                      {entryParcelsTable.length.toString().padStart(3, "0")}
                    </td>
                    <td className="text-center">
                      {simulatorData?.installments_interest_entry ? formatCurrency(entryParcelCalc || 0) : formatCurrency((entryParcelCalc || 0) - (entryInterest || 0))}
                    </td>
                  </tr>
                )}
                {(oneTimeParcelValue !== 0 && oneTimeParcelDate) && (
                  <tr>
                    <td>
                      <span className="text-dark">Parcela Única</span>
                    </td>
                    <td className="text-center">001</td>
                    <td className="text-center">
                      {formatCurrency(oneTimeParcelValue || 0)}
                    </td>
                  </tr>
                )}
                {constructionParcelsTable && Array.isArray(constructionParcelsTable) && constructionParcelsTable.length > 0 && (
                  <tr>
                    <td>
                      <span className="text-dark">Parcela de Construção</span>
                    </td>
                    <td className="text-center">
                      {constructionParcelsTable.length
                        .toString()
                        .padStart(3, "0")}
                    </td>
                    <td className="text-center">
                      {formatCurrency(constructionTotalValue || 0)}
                    </td>
                  </tr>
                )}
                {intermediateParcelsTable && Array.isArray(intermediateParcelsTable) && intermediateParcelsTable.length > 0 && (
                  <tr>
                    <td>
                      <span className="text-dark">Parcela Intermediária</span>
                    </td>
                    <td className="text-center">
                      {intermediateParcelsTable.length
                        .toString()
                        .padStart(3, "0")}
                    </td>
                    <td className="text-center">
                      {formatCurrency(intermediateTotalValue || 0)}
                    </td>
                  </tr>
                )}
                {financingParcelsTable && Array.isArray(financingParcelsTable) && financingParcelsTable.length > 0 && (
                  <tr>
                    <td>
                      <span className="text-dark">Parcela Financiamento</span>
                    </td>
                    <td className="text-center">
                      {financingParcelsTable.length.toString().padStart(3, "0")}
                    </td>
                    <td className="text-center">
                      {formatCurrency(financingParcelCalc || 0)}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="invoice-price">
            <div className="invoice-price-left">
              <div className="invoice-price-row">
                {/* {console.log(entryParcelCalc !== 0)} */}
                {/* {(intermediateTotalValue !== 0 ||
                  constructionTotalValue !== 0 ||
                  entryParcelCalc !== 0) &&
                  financingParcelCalc ? (
                  <></>
                ) : (
                  <>
                    {entryParcelCalc && entryParcelCalc !== 0 && (
                      <div className="sub-price">
                        <small>Valor da Entrada</small>
                        <span className="text-dark">
                          {simulatorData.installments_interest_entry ? formatCurrency(entryParcelCalc) : formatCurrency(entryParcelCalc - entryInterest)}
                        </span>
                      </div>
                    )}
                    {entryParcelCalc && entryParcelCalc !== 0 && financingParcelCalc && (
                      <div className="sub-price">
                        <i className="fa fa-plus text-muted"></i>
                      </div>
                    )}
                    {financingParcelCalc && (
                      <div className="sub-price">
                        <small>Valor Financiado</small>
                        <span className="text-dark">
                          {formatCurrency(financingParcelCalc)}
                        </span>
                      </div>
                    )}
                  </>
                )} */}
              </div>
            </div>
            <div className="invoice-price-right">
              <small>Valor da Compra</small>{" "}
              <span className="fw-bold">
                {formatCurrency(
                  (simulatorData?.installments_interest_entry ? parseFloat(entryParcelCalc || 0) : (parseFloat(entryParcelCalc || 0) - parseFloat(entryInterest || 0))) +
                  parseFloat(financingParcelCalc || 0) +
                  parseFloat(intermediateTotalValue || 0) +
                  parseFloat(constructionTotalValue || 0) +
                  (oneTimeParcelDate !== null ? parseFloat(oneTimeParcelValue || 0) : 0)
                )}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="invoice-content">
          <div className="table-responsive">
            <table className="table table-invoice">
              <thead>
                <tr>
                  <th className="text-start">PARCELA</th>
                  <th className="text-center" width="20%">
                    VALOR
                  </th>
                  <th className="text-center" width="20%">
                    DATA VENCIMENTO
                  </th>
                </tr>
              </thead>
              <tbody>
                {oneTimeInstallments && Array.isArray(oneTimeInstallments) &&
                  oneTimeInstallments.map((o) => (
                    <tr key={o?.sequence_number || Math.random()}>
                      <td>{o?.sequence_number || 'N/A'}</td>
                      <td className="text-center">{formatCurrency(o?.value || 0)}</td>
                      <td className="text-center">
                        {o?.due_date ? format(parseISO(o.due_date), "dd/MM/yyyy") : 'Data não informada'}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="invoice-price">
            <div className="invoice-price-left">
              <div className="invoice-price-row"></div>
            </div>
            <div className="invoice-price-right">
              <small>Valor da Compra</small>{" "}
              <span className="fw-bold">
                {findValueAndPercentage &&
                  formatCurrency(findValueAndPercentage?.value || 0)}
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="card mb-5 p-3 bg-danger-300 rounded-3 bg-opacity-75">
        <span className="text-center">
          <i className="bi bi-info-circle-fill me-1"></i>
          <b>Atenção</b>
          <br />
          Simulação informativa das condições de pagamento para esta data e hora{" "}
          <b>{formattedDateShort.replace(", ", " - ")}</b>, sujeito a alteração
          de valores, reserva ou venda para outro interessado.
        </span>
      </div>

      {!toggle && (
        <>
          {simulationData?.entry && simulationData.entry.installments && Array.isArray(simulationData.entry.installments) && simulationData.entry.installments.length > 0 && (
            <div className="invoice-parcels mb-5"
              style={{ pageBreakInside: 'avoid' }}>
              <h4>Parcelas de Entrada</h4>
              <hr />
              {print ? (
                <DataTable
                  stripedRows
                  value={entryViewTable}
                  size={"small"}
                >
                  <Column field="sequence_number" header="Parcela"></Column>
                  <Column field="value" header="Valor"></Column>
                  <Column field="due_date" header="Data pagamento"></Column>
                </DataTable>
              ) : (
                <DataTable
                  stripedRows
                  value={entryViewTable}
                  size={"small"}
                  paginator
                  rows={5}
                  rowsPerPageOptions={[5, 10, 25]}
                >
                  <Column field="sequence_number" header="Parcela"></Column>
                  <Column field="value" header="Valor"></Column>
                  <Column field="due_date" header="Data pagamento"></Column>
                </DataTable>
              )}
            </div>
          )}

          {simulationData?.construction && simulationData.construction.installments && Array.isArray(simulationData.construction.installments) && simulationData.construction.installments.length > 0 && (
            <div className="invoice-parcels mb-5"
              style={{ pageBreakInside: 'avoid' }}>
              <h4>Parcelas de Construção</h4>
              <hr />
              {print ? (
                <DataTable
                  stripedRows
                  value={constructionViewTable}
                  size={"small"}
                >
                  <Column field="sequence_number" header="Parcela"></Column>
                  <Column field="value" header="Valor"></Column>
                  <Column field="due_date" header="Data pagamento"></Column>
                </DataTable>
              ) : (
                <DataTable
                  stripedRows
                  value={constructionViewTable}
                  size={"small"}
                  paginator
                  rows={5}
                  rowsPerPageOptions={[5, 10, 25]}
                >
                  <Column field="sequence_number" header="Parcela"></Column>
                  <Column field="value" header="Valor"></Column>
                  <Column field="due_date" header="Data pagamento"></Column>
                </DataTable>
              )}
            </div>
          )}

          {simulationData?.intermediate && simulationData.intermediate.installments && Array.isArray(simulationData.intermediate.installments) && simulationData.intermediate.installments.length > 0 && (
            <div className="invoice-parcels mb-5"
              style={{ pageBreakInside: 'avoid' }}>
              <h4>Parcelas Intermediárias</h4>
              <hr />
              {print ? (
                <DataTable
                  stripedRows
                  value={intermediateViewTable}
                  size={"small"}
                >
                  <Column field="sequence_number" header="Parcela"></Column>
                  <Column field="value" header="Valor"></Column>
                  <Column field="due_date" header="Data pagamento"></Column>
                </DataTable>
              ) : (
                <DataTable
                  stripedRows
                  value={intermediateViewTable}
                  size={"small"}
                  paginator
                  rows={5}
                  rowsPerPageOptions={[5, 10, 25]}
                >
                  <Column field="sequence_number" header="Parcela"></Column>
                  <Column field="value" header="Valor"></Column>
                  <Column field="due_date" header="Data pagamento"></Column>
                </DataTable>
              )}
            </div>
          )}

          {((simulationData?.financing?.installments && simulationData.financing.installments.length > 20) || 
            (simulationData?.entry?.installments && simulationData.entry.installments.length > 20)) && (
            <div style={{ pageBreakBefore: "always" }}></div>
          )}

          {simulationData?.financing && simulationData.financing.installments && Array.isArray(simulationData.financing.installments) && simulationData.financing.installments.length > 0 && (
            <div
              className="invoice-parcels mb-5"
              style={{ pageBreakInside: 'avoid' }}
            >
              <h4>Parcelas de Financiamento</h4>
              <hr />
              {print ? (
                <DataTable
                  stripedRows
                  value={financingViewTable}
                  size={"small"}
                >
                  <Column field="sequence_number" header="Parcela"></Column>
                  <Column field="value" header="Valor"></Column>
                  <Column field="due_date" header="Data pagamento"></Column>
                </DataTable>
              ) : (
                <DataTable
                  stripedRows
                  value={financingViewTable}
                  size={"small"}
                  paginator
                  rows={5}
                  rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
                >
                  <Column field="sequence_number" header="Parcela"></Column>
                  <Column field="value" header="Valor"></Column>
                  <Column field="due_date" header="Data pagamento"></Column>
                </DataTable>
              )}
            </div>
          )}
        </>
      )}

      <div className="invoice-footer">
        <p className="text-center mb-5px fw-bold">
          {simulatorData?.enterprise_name || 'Empresa'}
        </p>
        {/* <p className="text-center">
          <span className="me-10px">
            {memberData.email}
          </span>
        </p> */}
      </div>
    </div>
  );

  const handlePrint = () => {
    const content = <Content print={true} />;
    const htmlString = ReactDOMServer.renderToString(content);

    const options = {
      margin: 18,
      filename: `Simulação ${simulatorData?.enterprise_name || 'Empresa'} - ${nomenclature?.[0]?.value || 'Bloco'} ${simulatorData?.block_name || ''} ${nomenclature?.[1]?.value || 'Lote'} ${simulatorData?.land_name || ''}`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "letter", orientation: "portrait" },
    };

    const addPageNumbers = (pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Página ${i} de ${totalPages}`,
          pdf.internal.pageSize.getWidth() - 100,
          pdf.internal.pageSize.getHeight() - 30
        );
      }
    };

    const generatePDF = () => {
      const pdf = new jsPDF(options.jsPDF);
      html2pdf()
        .from(htmlString)
        .set(options)
        .toPdf()
        .get("pdf")
        .then(function (pdfDoc) {
          addPageNumbers(pdfDoc);
          pdfDoc.save(options.filename);
        });
    };

    generatePDF();
  };

  return (
    <div>
      <Content print={false} />
    </div>
  );
}
